Object.defineProperty(exports, "__esModule", { value: true });
var Max = /** @class */ (function () {
    function Max() {
    }
    /**
     * Returns the maximum element of the sequence or `null` if sequence is empty.
     *
     * @returns {T}
     */
    Max.prototype.max = function () {
        var result = null;
        for (var item = this.iterator.next(); !item.done; item = this.iterator.next()) {
            if (result == null || item.value > result) {
                result = item.value;
            }
        }
        return result;
    };
    return Max;
}());
exports.Max = Max;
//# sourceMappingURL=max.js.map